import moment from 'moment-timezone';
import momentTz from 'moment-timezone';

import { SHORT_WEEK_DAYS, USA_DATE_FORMAT } from '~constants';

export function formatDate(date: string, format = 'MM/DD/YYYY') {
	return momentTz.tz(date, momentTz.tz.guess()).format(format);
}

const LAUNDROWORKS_WALL_CLOCK_FORMAT = 'YYYY-MM-DD HH:mm:ss';

/**
 * Formats the naive wall clock Laundroworks sends for VAC-related timestamps — both directly
 * (the Laundroworks pending/recent changes feeds) and via Snowflake (the VAC list's
 * communication/collection dates, themselves converted from UTC into the VAC's own location
 * timezone with `CONVERT_TIMEZONE`) — into `MM/DD/YYYY h:mma`.
 *
 * Matched with an exact `YYYY-MM-DD HH:mm:ss` format, not a lenient parse: the string carries
 * no offset because it is already local to wherever it was generated, so reformatting it must
 * not apply any zone conversion. Returns null rather than guessing when the value doesn't match
 * that shape, so each caller can decide its own placeholder or fallback.
 */
export function formatLaundroworksWallClock(
	value: string | null | undefined,
): string | null {
	if (!value) {
		return null;
	}
	const parsed = moment(value, LAUNDROWORKS_WALL_CLOCK_FORMAT, true);
	return parsed.isValid() ? parsed.format(`${USA_DATE_FORMAT} h:mma`) : null;
}

export const getShortWeekDay = (day: number) => SHORT_WEEK_DAYS[day].concat('.');

export const addMsToDate = (date: string, ms: number, format = 'MM/DD/YYYY') => {
	return momentTz.tz(date, momentTz.tz.guess()).add(ms, 'ms').format(format);
};

export const formatSecondsToMinutesAndSeconds = (seconds: number) => {
	const duration = moment.duration(seconds, 'seconds');
	const minutes = duration.minutes();
	const remainingSeconds = duration.seconds();

	return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`;
};
